import { createRoot } from 'react-dom/client'
import React, { useEffect, useRef, useState } from 'react'
import JSEncrypt from 'jsencrypt'
import CreateReactScript from './Utils/CreateReactScript'
import AuthRest from './actions/AuthRest'
import ReCAPTCHA from 'react-google-recaptcha'
import { Link } from '@inertiajs/react'
import SelectFormGroup from './components/form/SelectFormGroup'
import InputFormGroup from './components/form/InputFormGroup'
import Modal from './components/Modal'
import HtmlContent from './Utils/HtmlContent'
import Select from 'react-select';
import Swal from 'sweetalert2'
import ModalGoogle from './components/ModalGoogle'

export default function Register({ PUBLIC_RSA_KEY, RECAPTCHA_SITE_KEY, token, terms = 'Terminos y condiciones', APP_URL, termsAndCondicitions, politicas }) {

  document.title = 'Registro | Las Doñas'

  const customStyles2 = {
    control: (provided) => ({
      ...provided,
      outline: 'none',
      boxShadow: 'none',
      borderColor: 'transparent',
      borderRight: 'none',
      '&:hover': {
        borderColor: 'transparent',
      },
    }),
    menu: (provided) => ({
      ...provided,
      width: '90%', // Asegura que el menú no sobresalga del contenedor principal
    }),
    option: (provided) => ({
      ...provided,
      fontSize: '0.875rem', // Ajusta el tamaño de fuente de las opciones
      padding: '8px 12px', // Ajusta el padding de las opciones
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };
  const jsEncrypt = new JSEncrypt()
  jsEncrypt.setPublicKey(PUBLIC_RSA_KEY)


  // Estados
  const [loading, setLoading] = useState(true)
  const [captchaValue, setCaptchaValue] = useState(null)
  const [found, setFound] = useState(false)

  const documentTypeRef = useRef()
  const documentNumberRef = useRef()
  const nameRef = useRef()
  const lastnameRef = useRef()
  // const emailRef = useRef()
  const [email, setEmail] = useState('')
  const passwordRef = useRef()
  const confirmationRef = useRef()
  const termsRef = useRef()

  const modalitem = useRef()

  const [modalMaps, setModalMaps] = useState(false)

  const termsModalRef = useRef();

  useEffect(() => {
    setLoading(false)
  }, [null])

  const onRegisterSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)


    const password = passwordRef.current.value
    const confirmation = confirmationRef.current.value



    if (password != confirmation) {
      return Swal.fire({
        icon: 'warning',
        title: 'Error',
        text: 'Las contraseñas no coinciden',
        confirmButtonText: 'Ok'
      })
    }

    if (!captchaValue) return Swal.fire({
      icon: 'warning',
      title: 'Error',
      text: 'Por favor, complete el captcha',
      confirmButtonText: 'Ok'
    })

    // if (found) return Swal.fire({
    //   icon: 'warning',
    //   title: 'Error',
    //   text: 'El numero de documento ya esta registrado',
    //   confirmButtonText: 'Ok'
    // })

    const request = {
      document_type: $(documentTypeRef.current).val(),
      document_number: documentNumberRef.current.value,
      name: nameRef.current.value,
      lastname: lastnameRef.current.value,
      email: email,
      password: jsEncrypt.encrypt(password),
      confirmation: jsEncrypt.encrypt(confirmation),
      terms: termsRef.current.checked,
      captcha: captchaValue,
      _token: token
    }

    const result = await AuthRest.signup(request)
    if (!result) return setLoading(false)

    // if (result) location.href = result;
    if (result) location.href = `./confirm-email/${result}`;
    setLoading(false)
  }

  const onDocumentTypeChange = (e) => {
    documentNumberRef.current.value = ''
    setFound(false)
  }
  const backgroundImageUrl = '/images/ux/imagen_Registro_escritorio.webp'
  const options = [
    { value: 'DNI', label: 'DNI - Documento Nacional de Identidad' },
    { value: 'CE', label: 'CE - Carnet de Extranjeria' },
  ];

  const handlemodalMaps = () => {
    setModalMaps(!modalMaps)
  }

  const handleModalpolic = (e) => {
    const tipo = e.target.getAttribute('data-tipo')


    modalitem.current = tipo
    handlemodalMaps()
  }

  return (
    <>

      <div className="min-h-screen w-full bg-white flex flex-col lg:flex-row overflow-hidden">
        <div className="w-96 h-60   sm:hidden absolute top-0">
          <img src="/images/ux/headerLogo.png" alt="" className="absolute top-[23px] left-[18px] z-20 w-36 h-[46px]" />
          <img className="w-96 h-60 left-0 top-0 absolute object-cover object-left" src="/images/ux/Imagen_registro_mobile.png" />
          <div className="w-96 h-60 bg-gradient-to-b from-white/30 to-white absolute top-0 left-0 z-10"></div>
        </div>

        <div className="basis-1/2 hidden md:block font-poppins">
          <div className="basis-1/2 hidden md:block">
            <div className="bg-cover bg-center bg-no-repeat w-full h-full">
              <img src={backgroundImageUrl} alt="" className='w-[564px]  object-cover h-[1158px]' />
            </div>
          </div>
        </div>

        <div className="w-full md:basis-1/2 text-[#151515] flex  items-center  relative z-40">

          <div className="w-full md:max-w-[520px] flex flex-col gap-4 py-6  px-[39px] md:px-0   ">

            {/* Logo */}
            <div className=" justify-center hidden md:flex">
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/9fa2a0c325b5f04cbe78e55d0659a5a18ea64060?width=468"
                alt="LAS DOÑAS LOGOTIPO"
                className="w-[234px] h-auto"
              />
            </div>

            <div className="flex flex-col w-full">
              {/* Title */}
              <div className=" mb-10 ">
                <h1 className="text-[#4B2907] mt-[186px] sm:mt-0 text-3xl text-center font-PlusJakartaSans_Bold font-bold mb-4">
                  Regístrate
                </h1>
                <p className="text-[#292929] text-[16px] font-medium font-PlusJakartaSans_Regular text-center  leading-snug">
                  Regístrate y descubre un mundo donde cada flor cuenta una historia.
                </p>
              </div>

              <form onSubmit={onRegisterSubmit} className='flex flex-col gap-5 w-full'>
                {/* Name and Lastname */}
                <div className="grid grid-cols-1  md:grid-cols-2 gap-4 w-full">
                  <div className="flex flex-col">
                    <label className="text-[#292929] text-base font-medium font-PlusJakartaSans_Regular mb-1">
                      Nombre
                    </label>
                    <input
                      ref={nameRef}
                      className="h-14  rounded-md border border-neutral-200 text-stone-500 text-base font-medium font-PlusJakartaSans_Regular outline-none focus:ring-2 focus:ring-orange-400"
                      type="text"
                      placeholder="Nombre"
                      required
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-[#292929] text-base font-medium font-PlusJakartaSans_Regular mb-1">
                      Apellido
                    </label>
                    <input
                      ref={lastnameRef}
                      className="h-14    rounded-md border border-neutral-200 text-stone-500 text-base font-medium font-PlusJakartaSans_Regular outline-none focus:ring-2 focus:ring-orange-400"
                      type="text"
                      placeholder="Apellido"
                      required
                    />
                  </div>
                </div>

                {/* Document Type and Number */}
                <div className="grid grid-cols-1  md:grid-cols-2 gap-4">
                  <div className="flex flex-col">
                    <label className="text-[#292929] text-base font-medium font-PlusJakartaSans_Regular mb-1">
                      Tipo de documento
                    </label>
                    <select
                      className="h-14 px-3 rounded-md border border-neutral-200 text-stone-500 text-base  font-PlusJakartaSans_Regular outline-none focus:ring-2 focus:ring-orange-400"
                      ref={documentTypeRef}
                      onChange={onDocumentTypeChange}
                      required
                    >
                      <option value="DNI">DNI</option>
                      <option value="CE">CE</option>
                    </select>
                  </div>
                  <div className="flex flex-col">
                    <label className="text-[#292929] text-base font-medium font-PlusJakartaSans_Regular mb-1">
                      Número de documento
                    </label>
                    <input
                      ref={documentNumberRef}
                      className="h-14  rounded-md border border-neutral-200 text-stone-500 text-base font-medium font-PlusJakartaSans_Regular outline-none focus:ring-2 focus:ring-orange-400"
                      type="text"
                      placeholder="000000000"
                      required
                    />
                  </div>
                </div>

                {/* Email */}
                <div className="flex flex-col">
                  <label className="text-[#292929] text-base font-medium font-PlusJakartaSans_Regular mb-1">
                    Email
                  </label>
                  <div className="relative">
                    <input

                      value={email}
                      className="w-full h-14  rounded-md border border-neutral-200 text-stone-500 text-base font-medium font-PlusJakartaSans_Regular outline-none focus:ring-2 focus:ring-orange-400"
                      type="email"
                      placeholder="TuEmail@gmail.com"
                      required
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <div className="absolute right-5 top-1/2 -translate-y-1/2 w-5 h-5  rounded-full flex items-center justify-center">

                      {email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"

                        >
                          <g clipPath="url(#clip0_264_120)">
                            <path fillRule="evenodd" clipRule="evenodd" d="M10 0C4.48438 0 0 4.48438 0 10C0 15.5156 4.48438 20 10 20C15.5156 20 20 15.5156 20 10C20 4.48438 15.5156 0 10 0Z" fill="#73B473" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M14.8359 6.62891C15.0781 6.87109 15.0781 7.26953 14.8359 7.51172L8.97656 13.3711C8.85547 13.4922 8.69531 13.5547 8.53516 13.5547C8.375 13.5547 8.21484 13.4922 8.09375 13.3711L5.16406 10.4414C4.92188 10.1992 4.92188 9.80078 5.16406 9.55859C5.40625 9.31641 5.80469 9.31641 6.04688 9.55859L8.53516 12.0469L13.9531 6.62891C14.1953 6.38281 14.5937 6.38281 14.8359 6.62891Z" fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0_264_120">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      )}

                    </div>
                  </div>
                </div>

                {/* Password */}
                <div className="flex flex-col">
                  <label className="text-[#292929] text-base font-medium font-PlusJakartaSans_Regular mb-1">
                    Contraseña
                  </label>
                  <div className="relative">
                    <input
                      ref={passwordRef}
                      className="w-full h-14  rounded-md border border-neutral-200 text-stone-500 text-lg font-medium font-PlusJakartaSans_Regular outline-none focus:ring-2 focus:ring-orange-400"
                      type="password"

                      required
                    />
                    <div className="absolute right-5 top-1/2 -translate-y-1/2 w-5 h-5">
                      <img src="/images/ux/locked-computer.svg" alt="" />
                    </div>
                  </div>
                </div>

                {/* Confirm Password */}
                <div className="flex flex-col">
                  <label className="text-[#292929] text-base font-medium font-PlusJakartaSans_Regular mb-1">
                    Confirme contraseña
                  </label>
                  <div className="relative">
                    <input
                      ref={confirmationRef}
                      className="w-full h-14  rounded-md border border-neutral-200 text-stone-500 text-lg font-medium font-PlusJakartaSans_Regular outline-none focus:ring-2 focus:ring-orange-400"
                      type="password"

                      required
                    />
                    <div className="absolute right-5 top-1/2 -translate-y-1/2 w-5 h-5">
                      <img src="/images/ux/locked-computer.svg" alt="" />
                    </div>
                  </div>
                </div>

                {/* Terms and Conditions */}
                <div className="flex items-start gap-3">
                  <input
                    ref={termsRef}
                    type="checkbox"
                    className="w-4 h-4 mt-1 rounded border border-neutral-200 bg-orange-50"
                    id="checkbox-signup"
                    required
                  />
                  <label htmlFor="checkbox-signup" className="text-[#292929] text-base font-normal font-PlusJakartaSans_Regular">
                    Acepto las{' '}
                    <span className="text-[#73B473] font-semibold cursor-pointer" data-tipo='PoliticaPriv' onClick={handleModalpolic}>
                      Políticas de Privacidad
                    </span>
                    {' '}y los{' '}
                    <span className="text-[#73B473] font-semibold cursor-pointer" data-tipo='terminosUso' onClick={handleModalpolic}>
                      Términos de Uso
                    </span>
                  </label>
                </div>

                {/* ReCAPTCHA */}
                <ReCAPTCHA
                  className='mx-auto mb-3'
                  sitekey={RECAPTCHA_SITE_KEY}
                  onChange={setCaptchaValue}
                  style={{ display: "block", width: 'max-content' }}
                />

                {/* Register Button */}
                <button
                  className="w-full h-16 bg-[#FF8555] rounded-[10px] text-white text-lg font-bold font-PlusJakartaSans_Regular hover:opacity-90 transition-opacity"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <i className='fa fa-spinner fa-spin'></i> Verificando
                    </>
                  ) : (
                    'Registrarme'
                  )}
                </button>
              </form>

              {/* Divider */}
              <div className="flex items-center my-8">
                <div className="flex-1 h-px bg-neutral-200"></div>
                <span className="mx-4 text-neutral-500 text-base font-light font-PlusJakartaSans_Regular">O</span>
                <div className="flex-1 h-px bg-neutral-200"></div>
              </div>

              {/* Google Sign Up */}
              <a
                href="/login-google"
                className="w-full h-16 bg-gray-100 rounded-[10px] flex items-center justify-center gap-4 hover:bg-gray-200 transition-colors"
              >
                <img
                  src="/img_donas/Google1.png"
                  alt="Google"
                  className="w-7 h-7"
                />
                <span className="text-[#292929] text-lg font-semibold font-PlusJakartaSans_Regular">
                  Registrarse con Google
                </span>
              </a>

              {/* Login Link */}
              <div className="text-center mt-8">
                <p className="text-[#292929] md:text-lg text-base font-normal font-PlusJakartaSans_Regular">
                  ¿Ya tienes cuenta en las Doñas?{' '}
                  <a href="/login" className="text-[#FF8555] underline hover:opacity-80 md:text-[18px]  text-base cursor-pointer">
                    Inicia sesión aquí
                  </a>
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>


      <ModalGoogle handlemodalMaps={handlemodalMaps}
        isModalOpen={modalMaps} tittle={modalitem.current == 'PoliticaPriv' ? 'Políticas de Privacidad' : 'Terminos de Uso'}
      >
        {
          modalitem.current == 'PoliticaPriv' ? <HtmlContent html={politicas?.content ?? ''} /> : <HtmlContent html={termsAndCondicitions?.content ?? ''} />
        }
      </ModalGoogle>


    </>)
};


